var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "url(#paint0_linear_538_22860)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6096 24.7156C38.0511 21.7681 35.8054 20.1833 32.7369 19.1258L33.7325 15.132L31.3025 14.5273L30.3322 18.4156C29.6938 18.2553 29.0385 18.1062 28.3846 17.9572L29.3619 14.0436L26.9319 13.4375L25.9363 17.4298C25.4075 17.3089 24.8872 17.1908 24.3838 17.0642L24.3866 17.0516L21.0341 16.2148L20.3872 18.8108C20.3872 18.8108 22.1915 19.2242 22.1535 19.2495C23.1379 19.4956 23.315 20.1467 23.2855 20.6642L22.1521 25.2134C22.2196 25.2303 22.3068 25.2556 22.4052 25.2936L22.1479 25.2303L20.5588 31.6034C20.4379 31.9016 20.1327 32.3502 19.4436 32.18C19.469 32.2152 17.6774 31.7398 17.6774 31.7398L16.4708 34.5214L19.6349 35.3103C20.2227 35.458 20.7993 35.6127 21.366 35.7575L20.3605 39.7962L22.7891 40.4009L23.7847 36.4072C24.4485 36.5858 25.0925 36.7517 25.7225 36.9092L24.7297 40.8861L27.1597 41.4908L28.1652 37.4605C32.3108 38.2452 35.4271 37.9287 36.7391 34.1797C37.7966 31.1619 36.6871 29.4195 34.506 28.2847C36.095 27.9191 37.2904 26.8742 37.6096 24.7156ZM32.0549 32.5034C31.3054 35.5227 26.2218 33.89 24.5736 33.4808L25.9096 28.13C27.5577 28.542 32.841 29.3563 32.0549 32.5034ZM32.8072 24.672C32.1224 27.4184 27.8924 26.022 26.5213 25.6803L27.7307 20.8287C29.1018 21.1705 33.5216 21.8075 32.8072 24.672Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_22860",
    x1: 27.9849,
    y1: -0.01344,
    x2: 27.9849,
    y2: 55.9944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.418ae0c4fea1a2b9413996ac86334673.svg";
export { ForwardRef as ReactComponent };